<template>
  <ValidationObserver ref="form">
    <b-form class="form--auth"
            @submit.prevent
            v-stream:submit="onSubmit$"
    >
      <div>
        <h3>忘記密碼</h3>
        <AGCInput
          v-model.trim="username"
          vid="name"
          name="帳戶名稱"
          rules="required|username|max:15"
          class="mb-4"
          label="輸入帳戶名稱以重設密碼"
          sub-label="(如未能提供，請聯絡
          <a href='mailto:eCoupon@ulifestyle.com.hk'>eCoupon@ulifestyle.com.hk</a>)"
          placeholder="帳戶名稱"
          required
        ></AGCInput>
        <b-button type="submit"
                  variant="primary"
                  size="lg"
                  :disabled="loading"
                  block
        >
          下一步
        </b-button>
        <b-button class="btn--back"
                  to="/login"
                  variant="link"
                  block
        >
          返回登入
        </b-button>
      </div>
      <div v-if="loading" class="form__overlay">
        <LoadingSpinner></LoadingSpinner>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { switchMap, tap } from 'rxjs/operators';
import { BForm, BButton } from 'bootstrap-vue';
import { getErrorMsg } from '@/helpers/error-msg';
import http from '../../helpers/http';
import toastSettings from '../../helpers/toast-settings';
import formMixin from '../../mixins/form';
import AGCInput from '../../components/form/AGCInput.vue';
import LoadingSpinner from '../../components/LoadingSpinner.vue';

export default {
  mixins: [formMixin],
  components: {
    BForm,
    AGCInput,
    BButton,
    LoadingSpinner,
  },
  data: () => ({
    username: null,
    loading: false,
  }),
  domStreams: ['onSubmit$'],
  subscriptions() {
    return {
      submit: this.onSubmit$
        .pipe(
          switchMap(this.validate),
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => http({
            method: 'POST',
            url: '/agc-merchant-api/auth/forgetPassword',
            data: {
              username: this.username,
            },
          }, {
            next: ({ ref }) => {
              this.$router.push({
                path: '/sent',
                query: { ref },
              });
            },
            error: ({ data: { msg } }) => {
              this.$bvToast.toast(getErrorMsg(msg), {
                ...toastSettings,
                title: '錯誤',
                toaster: 'b-toaster-top-center',
              });
            },
            complete: () => {
              this.loading = false;
            },
          })),
        ),
    };
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/form--auth";
</style>

<style scoped lang="scss">
.form--auth {
  &::v-deep legend {
    font-size: 1rem;
    color: #3A4047;
    padding-bottom: 0.625rem;
  }
}

.btn--back {
  margin-top: 1.25rem;
  padding: 0 0.375rem;
  border: 0;
  color: #318ce1;

  &:hover, &:focus {
    text-decoration: none;
  }
}
</style>
